import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { colorsV2 } from '../../../../colors-v2';
import { Typography } from '../../../../DesignSystemV2/Typography';

interface NumberingElementProps extends RenderElementProps {}

export const NumberingElement = (props: NumberingElementProps) => {
  const { children } = props;

  return (
    <Typography.Text
      className="numbering-element"
      variant="semi-bold/10"
      style={{
        color: colorsV2.white100,
        backgroundColor: colorsV2.gray100,
        borderRadius: 16,
        padding: 3,
      }}
    >
      <span contentEditable="false"> </span>
      {children}
      <span contentEditable="false"> </span>
    </Typography.Text>
  );
};
